export default __webpack_public_path__ + "static/media/carousel6.1f6c56ee.png";